/* eslint-disable eqeqeq */
import { isProd } from 'constants/urls';
import 'jquery';
import moment from 'moment';
import 'moment/locale/es';
import 'popper.js';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import 'styles/estilos.css';
import 'styles/overrides.scss';
import 'styles/primeOverrides.scss';
import 'styles/styles.scss';
import App from './App';
import { unregister } from './registerServiceWorker';
import { store } from './store';

if (process.env.REACT_APP_SHOW_CONSOLE_LOG === 'false') {
  console.log = function (...params) {};
}

if (process.env.NODE_ENV !== 'development') {
  console.table = () => {};
  console.log = () => {};
}

moment.locale('es');

function isIE() {
  var ua = navigator.userAgent;
  var is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
  return is_ie;
}

if (isProd()) {
  const id = 'GTM-M89RWW5';
  const script = document.querySelector(`#${id}`);
  if (!script) {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.id = i;
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', id);
  }
}
if (!isIE()) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <React.Fragment>
          <App />
        </React.Fragment>
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );

  unregister();
}
